import UploadingText from "./uploading-text";

export default UploadingText;
